import {
  useQuery,
  useQueryClient,
  type InfiniteData,
  type QueryClient,
} from '@tanstack/react-query';
import { catalogApi } from '@/api/endpoints/catalog';
import type { VideoListResponse, VideoReference } from '@/api/types';

export const videoQueryKey = (id: number) => ['video', id] as const;

/** Видео из уже загруженных страниц каталога — чтобы панель открывалась мгновенно. */
export function findVideoInCaches(
  queryClient: QueryClient,
  id: number,
): VideoReference | undefined {
  for (const [, data] of queryClient.getQueriesData<InfiniteData<VideoListResponse>>({
    queryKey: ['videos'],
  })) {
    for (const page of data?.pages ?? []) {
      const hit = page.data.find((v) => v.id === id);
      if (hit) return hit;
    }
  }
  return undefined;
}

/** Одно видео: посев из выдачи, иначе точечная догрузка (CAT-11). */
export function useVideo(id: number | null) {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: videoQueryKey(id ?? 0),
    enabled: id !== null,
    queryFn: async () => (await catalogApi.show(id!)).data,
    initialData: () => (id === null ? undefined : findVideoInCaches(queryClient, id)),
    initialDataUpdatedAt: () => Date.now(),
    staleTime: 60_000,
  });
}
